function getElementTranslateY(element) {
  var style = window.getComputedStyle(element);
  var transform = style.transform || style.webkitTransform;
  var translateY = transform.slice(7, transform.length - 1).split(', ')[5];
  return Number(translateY);
}

function isObject(val) {
  return val !== null && typeof val === 'object';
}

function isOptionDisabled(option) {
  return isObject(option) && option.disabled;
}

export function stopPropagation(event) {
  event.stopPropagation();
}

function preventDefault(event, isStopPropagation) {
  if (typeof event.cancelable !== 'boolean' || event.cancelable) {
    event.preventDefault();
  }

  if (isStopPropagation) {
    stopPropagation(event);
  }
}

const DEFAULT_DURATION = 200; // 惯性滑动思路:
// 在手指离开屏幕时，如果和上一次 move 时的间隔小于 `MOMENTUM_LIMIT_TIME` 且 move
// 距离大于 `MOMENTUM_LIMIT_DISTANCE` 时，执行惯性滑动

const MOMENTUM_LIMIT_TIME = 300;
const MOMENTUM_LIMIT_DISTANCE = 15;

class Touch {
  constructor() {
    this.elem = null;
    this.itemHeight = 44;
    this.baseOffset = this.itemHeight * (5 - 1) / 2;
    this.offset = 0;
    this.duration = 0;
    this.swipeDuration = 200;
  }

  range(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  start(ev, elem) {
    if (!this.elem) {
      this.elem = elem;
      this.options = this.elem.children;
      this.count = this.elem.children.length;
    }

    this.resetTouchStatus();
    this.startX = ev.touches[0].clientX;
    this.startY = ev.touches[0].clientY;

    if (this.moving) {
      var translateY = getElementTranslateY(this.elem);
      this.offset = Math.min(0, translateY - this.baseOffset);
      this.startOffset = this.offset;
    } else {
      this.startOffset = this.offset;
    }

    this.duration = 0;
    this.transitionEndTrigger = null;
    this.touchStartTime = Date.now();
    this.momentumOffset = this.startOffset;
  }

  move(ev) {
    var touch = ev.touches[0];
    this.deltaX = touch.clientX - this.startX;
    this.deltaY = touch.clientY - this.startY;
    this.offsetX = Math.abs(this.deltaX);
    this.offsetY = Math.abs(this.deltaY);
    this.direction = 'vertical';

    if (this.direction === 'vertical') {
      this.moving = true;
      preventDefault(ev, true);
    }

    this.offset = this.range(this.startOffset + this.deltaY, -(this.count * this.itemHeight), this.itemHeight);
    var now = Date.now();

    if (now - this.touchStartTime > MOMENTUM_LIMIT_TIME) {
      this.touchStartTime = now;
      this.momentumOffset = this.offset;
    }

    this.render();
  }

  end() {
    var distance = this.offset - this.momentumOffset;
    var duration = Date.now() - this.touchStartTime;
    var allowMomentum = duration < MOMENTUM_LIMIT_TIME && Math.abs(distance) > MOMENTUM_LIMIT_DISTANCE;

    if (allowMomentum) {
      this.momentum(distance, duration);
      return;
    }

    var index = this.getIndexByOffset(this.offset);
    this.duration = DEFAULT_DURATION;
    this.setIndex(index, true);
    this.render();
    setTimeout(() => {
      this.moving = false;
    }, 0);
  }

  resetTouchStatus() {
    this.direction = '';
    this.deltaX = 0;
    this.deltaY = 0;
    this.offsetX = 0;
    this.offsetY = 0;
  }

  getIndexByOffset(offset) {
    return this.range(Math.round(-offset / this.itemHeight), 0, this.count - 1);
  }

  setOptions(s, index, t) {
    if (!this.elem) {
      this.elem = document.querySelector(s);
    }
    this.options = this.elem.children;
    this.count = this.options.length;
    this.defaultIndex = index;
    this.setIndex(this.defaultIndex, t);
    this.render();
  }

  setIndex(index, emitChange) {
    var _this2 = this;

    index = this.adjustIndex(index) || 0;
    var offset = -index * this.itemHeight;

    var trigger = function trigger() {
      if (index !== _this2.currentIndex) {
        _this2.currentIndex = index;

        if (emitChange) {
          _this2.changeIndex(index);
        }
      }
    };

    if (this.moving && offset !== this.offset) {
      this.transitionEndTrigger = trigger;
    } else {
      trigger();
    }

    this.offset = offset;
  }

  adjustIndex(index) {
    index = this.range(index, 0, this.count);

    for (var i = index; i < this.count; i++) {
      if (!isOptionDisabled(this.options[i])) {
        return i;
      }
    }

    for (var _i = index - 1; _i >= 0; _i--) {
      if (!isOptionDisabled(this.options[_i])) {
        return _i;
      }
    }
  }

  momentum(distance, duration) {
    var speed = Math.abs(distance / duration);
    distance = this.offset + speed / 0.003 * (distance < 0 ? -1 : 1);
    var index = this.getIndexByOffset(distance);
    this.duration = +this.swipeDuration;
    this.setIndex(index, true);
    this.render();
  }

  onTransitionEnd() {
    this.stopMomentum();
  }

  stopMomentum() {
    this.moving = false;
    this.duration = 0;
    if (this.transitionEndTrigger) {
      this.transitionEndTrigger();
      this.transitionEndTrigger = null;
    }
  }

  render() {
    var wrapperStyle = {
      transform: 'translate3d(0, ' + (this.offset + this.baseOffset) + 'px, 0)',
      transitionDuration: this.duration + 'ms',
      transitionProperty: this.duration ? 'all' : 'none',
      lineHeight: this.itemHeight + 'px'
    };
    this.elem.style.transform = wrapperStyle.transform;
    this.elem.style.transitionDuration = wrapperStyle.transitionDuration;
    this.elem.style.transitionProperty = wrapperStyle.transitionProperty;
  }
}

export {Touch};